import React, { useState } from 'react'
import {
	Divider,
	AlertDialog,
	AlertDialogBody,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogContent,
	AlertDialogOverlay,
	AlertDialogCloseButton,
	Progress,
	Checkbox,
} from '@chakra-ui/react'
import {
	GA_CATEGORY_DIALOG_BOX,
	sectionDetailedTrack,
} from '../../containers/repository/repo.utils'
import { useLanguageContext } from '../../context/locale.context'
import ButtonCTA from './../globalComponents/button/index'
const ExportTimelineDialog = ({
	isOpen,
	onClose,
	exportTimeline,
	isLoading,
	isSysMessage,
	setSysMesssage,
}) => {
	const cancelRef = React.useRef()
	const {
		state: { locale },
	} = useLanguageContext()
	return (
		<AlertDialog
			isCentered
			isOpen={isOpen}
			leastDestructiveRef={cancelRef}
			onClose={onClose}
		>
			<AlertDialogOverlay>
				<AlertDialogContent
					background='gray.500'
					boxShadow='0px 6px 20px rgba(24, 39, 75, 0.2), 0px 10px 32px rgba(24, 39, 75, 0.1)'
					borderRadius='20px'
				>
					<AlertDialogHeader fontSize='1rem' fontWeight='500'>
						{locale['Export Timeline']}
					</AlertDialogHeader>
					<Divider />
					<AlertDialogCloseButton color='red.600' />
					<AlertDialogBody pt='1.6rem'>
						<Checkbox
							defaultIsChecked={isSysMessage}
							onChange={e => setSysMesssage(e.target.checked)}
							fontWeight='500'
							fontSize='0.875rem'
							color='gray.400'
							colorScheme='green'
						>
							{locale['Show system messages']}
						</Checkbox>
						{isLoading && <Progress size='xs' isIndeterminate />}
					</AlertDialogBody>

					<AlertDialogFooter pt='8rem'>
						<ButtonCTA
							variant='modalCloseButton'
							mr='1rem'
							onClick={e => {
								sectionDetailedTrack({
									category: GA_CATEGORY_DIALOG_BOX,
									action: 'Export Timeline Dialog',
									label: 'Close Selected',
								})
								onClose(e)
							}}
						>
							{locale['Cancel']}
						</ButtonCTA>
						<ButtonCTA
							variant='modalSubmitButton'
							onClick={() => {
								sectionDetailedTrack({
									category: GA_CATEGORY_DIALOG_BOX,
									action: 'Export Timeline Dialog',
									label: 'Exporting File Timeline',
								})
								exportTimeline()
							}}
							ml={3}
							isLoading={isLoading}
						>
							{locale['Export']}
						</ButtonCTA>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialogOverlay>
		</AlertDialog>
	)
}
export default ExportTimelineDialog
